import type { SITE_MODULATION_PERFORMANCE_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-modulation-performance-card/site-modulation-performance-card.fr.ts";

export const SITE_MODULATION_PERFORMANCE_CARD_ENGLISH_LOCALE = {
  title: "Modulations",
  subtitle: "Last 7 days",
  state: {
    UNKNOWN: "Unknown",
    NONE: "None",
    NOT_TESTED: "Not Tested",
    KO_DETECTED: "KO Detected",
    SUCCESS: "OK",
  },
} satisfies typeof SITE_MODULATION_PERFORMANCE_CARD_FRENCH_LOCALE;
